import React from 'react';
import { Popconfirm, Button } from 'antd';
import styles from './styles.module.scss';
import useTaskStatus from '$components/Admin/hooks/useTaskStatus';

const TaskButton = (props) => {
  const { task, productSlug, onClick, buttonText } = props;
  useTaskStatus(task, productSlug);

  return (
    <div className={styles.taskButtonContainer}>
      <Popconfirm title="Are you sure?" onConfirm={onClick}>
        <Button className={styles.taskButton}>{buttonText}</Button>
      </Popconfirm>
    </div>
  );
};

export default TaskButton;
